import axios from "axios";
import { apiEndPointV2 } from "../../config";

const cSharpApi = axios.create({
  baseURL: apiEndPointV2,
});

export default cSharpApi;
